import { AccountDateFilterRequest } from "../../../../_shared/models/account-date-filter-request.model";
import { SummaryRequest } from "../../../../_shared/models/summary-request.model";

export interface MaintenanceDashboardRequest {
  accountIds: string[];
  timeFrom: Date;
  timeTo: Date;
  page?: number;
  pageSize?: number;
}

export interface MaintenanceCostByAssetRequest extends AccountDateFilterRequest {
  ranking: MaintenanceCostByAssetRank;
}

export interface AssetDowntimeRequest extends AccountDateFilterRequest {
  vehicleModelIds?: number[];
}

export enum MaintenanceCostByAssetRank {
  Best = 1,
  Worst = 2
}

export interface PreventiveVsReactiveRequest extends AccountDateFilterRequest {
  assetIds?: number[];
}

export interface PreventiveVsReactiveSummaryRequest extends SummaryRequest {
  assetIds?: number[];
}
